// 组件对象，大写
import keywordSearchTable from './keywordSearchTable.vue'
export default keywordSearchTable
